export default __webpack_public_path__ + "static/media/Sev0.96fefe01.png";